const TOKEN_KEY = 'admin_token'
const REFRESH_KEY = 'admin_refresh_token'

export const getToken = () => localStorage.getItem(TOKEN_KEY)
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t)

export const getRefreshToken = () => localStorage.getItem(REFRESH_KEY)
export const setRefreshToken = (t) => localStorage.setItem(REFRESH_KEY, t)

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(REFRESH_KEY)
}
